import { baseApi } from '@api/baseApi';
import { MainParams, TradesDcParams, TradesDistrictParams, CustomerParams, SkuParams, SkuDcParams, SkuDistrictParams } from '@api/order-reporting/types-deliveries/DeliveriesParams';
import { MainReport, TradesDcReport, TradesDistrictReport, CustomerReport, SkuReport, SkuDcReport, SkuDistrictReport } from '@api/order-reporting/types-deliveries/DeliveriesReports';



export const deliveryApi = baseApi.injectEndpoints({
	overrideExisting: false,
	endpoints: (builder) => ({

		//#region "Main"
		getDeliveriesMain: builder.query<MainReport[], MainParams>({
			query: ({ dateFrom, dateTo }) => ({
				url: 'OrderReporting/GetCountryDeliveriesSummaryReport',
				params: { dateFrom, dateTo, countryCode: 'CZ' },
			}),
			providesTags: ['deliveriesMainReport']
		}),

		resetDeliveriesMain: builder.mutation<null, void>({
			queryFn: () => ({ data: null }),
			invalidatesTags: ['deliveriesMainReport'],
		}),
		//#endregion


		//#region "Trades Dc"
		getDeliveriesTradesDc: builder.query<TradesDcReport[], TradesDcParams>({
			query: ({ dateFrom, dateTo }) => ({
				url: 'OrderReporting/GetCountryDeliveriesTradesDepoReport',
				params: { dateFrom, dateTo },
			}),
			providesTags: ['deliveriesTradesDcReport']
		}),

		resetDeliveriesTradesDc: builder.mutation<null, void>({
			queryFn: () => ({ data: null }),
			invalidatesTags: ['deliveriesTradesDcReport'],
		}),
		//#endregion


		//#region "Trades District"
		getDeliveriesTradesDistrict: builder.query<TradesDistrictReport[], TradesDistrictParams>({
			query: ({ dateFrom, dateTo }) => ({
				url: 'OrderReporting/GetCountryDeliveriesTradesDistrictReport',
				params: { dateFrom, dateTo },
			}),
			providesTags: ['deliveriesTradesDistrictReport']
		}),

		resetDeliveriesTradesDistrict: builder.mutation<null, void>({
			queryFn: () => ({ data: null }),
			invalidatesTags: ['deliveriesTradesDistrictReport'],
		}),
		//#endregion


		//#region "Customer"
		getDeliveriesCustomer: builder.query<CustomerReport[], CustomerParams>({
			query: ({ dateFrom, dateTo }) => ({
				url: 'OrderReporting/GetCountryDeliveriesCustomerReport',
				params: { dateFrom, dateTo },
			}),
			providesTags: ['deliveriesCustomerReport']
		}),

		resetDeliveriesCustomer: builder.mutation<null, void>({
			queryFn: () => ({ data: null }),
			invalidatesTags: ['deliveriesCustomerReport'],
		}),
		//#endregion


		//#region "Sku"
		getDeliveriesSku: builder.query<SkuReport[], SkuParams>({
			query: ({ dateFrom, dateTo }) => ({
				url: 'OrderReporting/GetCountryDeliveriesSkuReport',
				params: { dateFrom, dateTo, countryCode: 'CZ' },
			}),
			providesTags: ['deliveriesSkuReport']
		}),

		resetDeliveriesSku: builder.mutation<null, void>({
			queryFn: () => ({ data: null }),
			invalidatesTags: ['deliveriesSkuReport'],
		}),
		//#endregion


		//#region "Sku Dc"
		getDeliveriesSkuDc: builder.query<SkuDcReport[], SkuDcParams>({
			query: ({ dateFrom, dateTo, materialId }) => ({
				url: 'OrderReporting/GetCountryDeliveriesSkuReportDcDetail',
				params: { dateFrom, dateTo, materialId, countryCode: 'CZ' },
			}),
			providesTags: ['deliveriesSkuDcReport']
		}),

		resetDeliveriesSkuDc: builder.mutation<null, void>({
			queryFn: () => ({ data: null }),
			invalidatesTags: ['deliveriesSkuDcReport'],
		}),
		//#endregion


		//#region "Sku District"
		getDeliveriesSkuDistrict: builder.query<SkuDistrictReport[], SkuDistrictParams>({
			query: ({ dateFrom, dateTo, materialId }) => ({
				url: 'OrderReporting/GetCountryDeliveriesSkuReportDistrictDetail',
				params: { dateFrom, dateTo, materialId, countryCode: 'CZ' },
			}),
			providesTags: ['deliveriesSkuDistrictReport']
		}),

		resetDeliveriesSkuDistrict: builder.mutation<null, void>({
			queryFn: () => ({ data: null }),
			invalidatesTags: ['deliveriesSkuDistrictReport'],
		}),
		//#endregion
	}),
});


export const { 
	useLazyGetDeliveriesMainQuery,
	useResetDeliveriesMainMutation,

	useLazyGetDeliveriesTradesDcQuery,
	useResetDeliveriesTradesDcMutation,

	useLazyGetDeliveriesTradesDistrictQuery,
	useResetDeliveriesTradesDistrictMutation,

	useLazyGetDeliveriesCustomerQuery,
	useResetDeliveriesCustomerMutation,

	useLazyGetDeliveriesSkuQuery,
	useResetDeliveriesSkuMutation,

	useLazyGetDeliveriesSkuDcQuery,
	useResetDeliveriesSkuDcMutation,

	useLazyGetDeliveriesSkuDistrictQuery,
	useResetDeliveriesSkuDistrictMutation } = deliveryApi;